/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import { array } from 'ember-data-model-fragments/attributes';
import type School from 'linced-app/models/school';

// Proto: xero.Batch.
export default class Batch extends Model {
  declare [Type]: 'xero/batch';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('number', { defaultValue: 0 })
  declare batchNo: number;

  @attr('string', { defaultValue: '' })
  declare manualJournalId: string;

  @attr('string', { defaultValue: '' })
  declare narration: string;

  @attr('number', { defaultValue: 0 })
  declare totalAmount: number;

  @attr('number', { defaultValue: 0 })
  declare batchStatus: number;

  @array('number')
  declare transactionIds: StatefulArray<number>;

  @attr('number', { defaultValue: 0 })
  declare noOfTransactions: number;

  @attr('string', { defaultValue: '' })
  declare heroClearingAccountCode: string;

  @attr('string', { defaultValue: '' })
  declare piaLedgerCode: string;

  @attr('boolean', { defaultValue: false })
  declare hasBeenReset: boolean;

  @attr('number', { defaultValue: 0 })
  declare piaAmount: number;

  @attr('string')
  declare journalDate: string | undefined;

  @array('string')
  declare warningMessages: StatefulArray<string>;
}
